/*
 * Action Types
 */

const PREFIX = 'GATEWAYS';

export const STUDENTS_ASSIGNMENTS_STATUSES_REQUEST = `${PREFIX}/STUDENTS_ASSIGNMENTS_STATUSES_REQUEST`;
export const STUDENTS_ASSIGNMENTS_STATUSES_SUCCESS = `${PREFIX}/STUDENTS_ASSIGNMENTS_STATUSES_SUCCESS`;

export const ASSIGN_ASSIGNMENTS_REQUEST = `${PREFIX}/ASSIGN_ASSIGNMENTS_REQUEST`;
export const ASSIGN_ASSIGNMENTS_SUCCESS = `${PREFIX}/ASSIGN_ASSIGNMENTS_SUCCESS`;

export const UNASSIGN_ASSIGNMENTS_REQUEST = `${PREFIX}/UNASSIGN_ASSIGNMENTS_REQUEST`;
export const UNASSIGN_ASSIGNMENTS_SUCCESS = `${PREFIX}/UNASSIGN_ASSIGNMENTS_SUCCESS`;

export const PREVIEW_ASSIGNMENT_REQUEST = `${PREFIX}/PREVIEW_ASSIGNMENT_REQUEST`;
export const PREVIEW_ASSIGNMENT_SUCCESS = `${PREFIX}/PREVIEW_ASSIGNMENT_SUCCESS`;


export const CLASSROOMS_REQUEST = `${PREFIX}/CLASSROOMS_REQUEST`;
export const CLASSROOMS_SUCCESS = `${PREFIX}/CLASSROOMS_SUCCESS`;

export const ERROR_DETECTED = `${PREFIX}/ERROR_DETECTED`;


// WEBPACK FOOTER //
// ./containers/gateways/gateways-action-types.js